export class MembershipTypeReferenceModel {
    public membershipTypeCode: string;
    public membershipTypeName: string;
    public sortSequence: number;
}